module.exports = __webpack_public_path__ + "img/teacher2.9eab544c.jpg";